import find from "../../store/find";
import User from "../../entities/user";
import Contact from "../../entities/contact";
import {uuid} from "../../@types/schema";
import ArrayMap from "../ArrayMap";

/**
 * Given a user, find the related contact.  If passed a null, return null.
 *
 * @param {User} user
 * @returns {Contact|null} - A contact object, or null if no contact found for user
 */
export const getContactFromUser = (user: User): Contact | null => {
    if (!user) return null;
    else if (user.contactId) return find<Contact>('contacts', user.contactId);
    else return null;
};

/**
 *
 * @param {uuid} userId
 * @returns {Contact|null}
 */
export const getContactFromUserId = (userId: uuid): Contact | null => {
    if (!userId) return null;

    const user = find<User>('users', userId);
    if (!user) return null;
    else return user.contactId ? find<Contact>('contacts', user.contactId) : null;
};

/**
 * Get a contact from an array of contacts, NOT from redux.
 *
 * @param {Contact[]} contacts
 * @param {uuid} contactId
 * @returns {Contact|null}
 */
export const getContactFromIdOverride = (contacts: Contact[] | ArrayMap<Contact>, contactId: uuid): Contact | null => {
    return find<Contact>('contacts', contactId);
}
